import { coerceStringZero } from "@/utils/utils.js";

/**
 * 解析 get_user_info_api 响应
 * @param {{ data?: { perform?: string, community?: string, level?: number } }} apiRes
 */
export function parseUserInfoApiResponse(apiRes) {
  const data = apiRes?.data;
  if (data == null || typeof data !== "object") {
    throw new Error("用户信息接口返回数据无效");
  }
  const perform = data.perform;
  const community = data.community;
  const level = data.level;
  if (perform == null || community == null || level == null) {
    throw new Error("用户信息接口缺少必要字段");
  }
  return {
    perform: String(coerceStringZero(perform)),
    community: String(coerceStringZero(community)),
    level: coerceStringZero(level),
  };
}

export function levelLabel(poolLevelRaw) {
  const n = Number(poolLevelRaw);
  if (!Number.isFinite(n) || n <= 0) return "—";
  if (n >= 1 && n <= 5) return `V${n}`;
  return String(n);
}

/**
 * 解析 get_referral_list 响应 data：钱包地址字符串数组
 * @returns {string[]}
 */
export function parseReferralListResponse(apiRes) {
  const data = apiRes?.data;
  if (!Array.isArray(data)) {
    throw new Error("直推列表接口返回数据无效");
  }
  return data
    .map((a) => (typeof a === "string" ? a.trim() : String(a || "").trim()))
    .filter(Boolean);
}
